
/* Shopify theme editor callbacks...  */
if (Shopify.designMode) {
  // This will only render in the theme editor
}

document.addEventListener("shopify:section:load",event=>{
    console.log("shopify:section:load")
    if(Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]){
      var slideshow = document.querySelector("#slideshow-"+event.detail.sectionId)
      Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId].stop();
      Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId] = (new BarracudaSlideshow(slideshow));
    }
    Barracuda.loadMapsScript();
    Barracuda.elements.init()
    Barracuda.reInit();
  })
  document.addEventListener("shopify:section:unload",event=>{
    console.log("shopify:section:unload")
    if(Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]){
      var slideshow = document.querySelector("#slideshow-"+event.detail.sectionId)
      Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId].stop();
    }
    Barracuda.sectionPaddingForBackgroundsTwo(event.target);
    setTimeout(Barracuda.elements.Overlapping.check.bind(Barracuda.elements.Overlapping),100);
  })
  document.addEventListener("shopify:section:select",event=>{
    console.log("shopify:section:select")
    Barracuda.loadMapsScript();
    Barracuda.elements.init()
    Barracuda.reInit();
  })
  document.addEventListener("shopify:section:deselect",event=>{
    console.log("shopify:section:deselect")
    if(Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]){
      Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId].start();
    }
    Barracuda.loadMapsScript();
  })
  document.addEventListener("shopify:section:reorder",event=>{
    console.log("shopify:section:reorder")
    Barracuda.loadMapsScript();
    Barracuda.elements.init()
    Barracuda.reInit();
  })
  document.addEventListener("shopify:block:select",event=>{
    console.log("shopify:block:select")
    if(Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]){
      var slideshow = Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]
      var slide = slideshow.slideshow.querySelector("#blockId-"+event.detail.blockId);
      slideshow.slideshow.dataset.start = slide.dataset.nth;
      if(event.detail.load)
        slideshow.set(parseInt(slide.dataset.nth), false);
      else
        slideshow.set(parseInt(slide.dataset.nth), true);
      slideshow.stop();
    }
    Barracuda.loadMapsScript();
  })
  document.addEventListener("shopify:block:deselect",event=>{
    console.log("shopify:block:deselect")
    if(Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]){
      var slideshow = Barracuda.elements.SlideshowObjects["slideshow-"+event.detail.sectionId]
      var slide = slideshow.slideshow.querySelector("#blockId-"+event.detail.blockId);
      slideshow.slideshow.dataset.start = slide.dataset.nth;
    }
    Barracuda.sectionPaddingForBackgroundsTwo();
    Barracuda.loadMapsScript();
  })